<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <AppForm 
            :key="appFormKey"
            :vo-name="isEdit ? 'ProductShippingGetVo' : 'ProductShippingAddVo'"
            :data="tmpProductShipping" 
            @changed="onFormChange"
          />
        </CCardBody>
        <CCardFooter>
          <LoadingStateButton
            @click="onAddOrUpdateProductShipping"
            :text="i18nMessage.Apply"
            color="primary"
            :loading="updateProductShippingLoading"
          />
          <template v-if="isEdit">
            &nbsp;
            <CButton color="secondary" @click="showDeleteModal = true">{{i18nMessage.Delete}}</CButton>
          </template>
          &nbsp;
          <CButton color="secondary" @click="goBack">{{i18nMessage.Back}}</CButton>
        </CCardFooter>
      </CCard>
    </CCol>
    <CModal
      :show.sync="showDeleteModal"
      :centered="true"
      color="default"
    >
      {{i18nMessage.PleaseInputTextToConfirmDelete}} <b>{{productShipping.name}}</b>
      <br/><br/>
      <CInput
          :placeholder="i18nMessage.PleaseInputText"
          v-model="deleteConfirmText"
        />
      <template #header>
        <span class="modal-title">{{i18nMessage.Delete}}？</span>
        <CButtonClose @click="showDeleteModal = false" class="text-dark"/>
      </template>
      <template #footer>
        <LoadingStateButton
          :disabled="deleteConfirmText !== productShipping.name"
          @click="onDeleteProductShipping"
          :text="i18nMessage.Apply"
          color="danger"
          :loading="deleteProductShippingLoading"
        />
        <CButton @click="showDeleteModal = false" color="secondary">{{i18nMessage.Cancel}}</CButton>
      </template>
    </CModal>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import { generateGUID } from '../../util'
import AppForm from '../../components/AppForm'
import LoadingStateButton from '../../components/LoadingStateButton'

export default {
  name: 'ProductShipping',
  components: {
    AppForm,
    LoadingStateButton,
  },
  data () {
    return {
      deleteConfirmText: null,
      showDeleteModal: false,
      isEdit: this.$route.params.id && this.$route.params.id.length > 0,
      tmpProductShipping: {},
      updateProductShippingLoading: false,
      deleteProductShippingLoading: false,
      appFormKey: generateGUID(),
      showSectionEditor: false,
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      productShipping: state => state.product.productShipping,
    }),
  },
  methods: {
    ...mapActions({
      getProductShipping: 'product/getProductShipping',
      updateProductShipping: 'product/updateProductShipping',
      addProductShipping: 'product/addProductShipping',
      deleteProductShipping: 'product/deleteProductShipping',
    }),
    ...mapMutations({
      setProductShipping: 'product/setProductShipping',
    }),
    goBack() {
      this.$router.push({path: '/product-shipping'})
    },
    onFormChange (data) {
      this.tmpProductShipping = {...data}
    },
    onAddOrUpdateProductShipping () {
      if (this.tmpProductShipping.id) {
        this.updateProductShippingLoading = true
        this.updateProductShipping(this.tmpProductShipping)
          .then(() => {
            this.updateProductShippingLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateProductShippingLoading = false
          })
      } else {
        this.updateProductShippingLoading = true
        this.addProductShipping(this.tmpProductShipping)
          .then(() => {
            this.updateProductShippingLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateProductShippingLoading = false
          })
      }
    },
    onDeleteProductShipping () {
      this.deleteProductShippingLoading = true
      this.deleteProductShipping(this.productShipping.id)
          .then(() => {
            this.deleteProductShippingLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.deleteProductShippingLoading = false
            this.showDeleteModal = false
          })
    }
  },
  mounted() {
    if (this.isEdit) {
      this.getProductShipping(this.$route.params.id).then(() => {
        this.tmpProductShipping = this.productShipping
      })
    }
  },
  destroyed() {
    this.setProductShipping({})
  }
}
</script>

<style>
  .section-modal.overlay {
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(51,51,51,0.7);
    z-index: 10;
  }

  .section-modal > .modal-header {
    padding: 5px;
  }

  .section-modal > .modal-content {
    overflow: hidden;
  }

  .section-modal > .modal-body {
    overflow-y: scroll;
    padding: 0px;
  }

  .section-modal > .modal-footer {
    display: none;
  }
</style>